(function () {
  const HOST_SELECTOR = 'square-placement, afterpay-placement';

  function isRendered(host) {
    if (!host) return false;
    // consider rendered if it has a real height
    if (host.getBoundingClientRect().height > 8) return true;
    // or if shadow DOM has visible children
    if (host.shadowRoot) {
      for (const n of host.shadowRoot.children) {
        const r = n.getBoundingClientRect();
        if (r.width > 0 && r.height > 0) return true;
      }
    }
    return false;
  }

  function tag(host) {
    if (!host) return;
    const rendered = isRendered(host);
    host.classList.toggle('bnpl-rendered', rendered);
  }

  function run() {
    const hosts = document.querySelectorAll(HOST_SELECTOR);
    hosts.forEach(host => {
      tag(host);
      // keep watching in case it renders late
      try { new ResizeObserver(() => tag(host)).observe(host); } catch {}
      try {
        new MutationObserver(() => tag(host))
          .observe(host, { childList: true, subtree: true });
        if (host.shadowRoot) {
          new MutationObserver(() => tag(host))
            .observe(host.shadowRoot, { childList: true, subtree: true });
        }
      } catch {}
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  window.addEventListener('load', () => {
    setTimeout(run, 300);
    setTimeout(run, 1200);
  });
})();
